import { Outlet } from 'react-router-dom';
import { Loader } from '@components/Loader';
import { FederatedErrorBoundary } from '@components/RemoteMicroFrontends/FederatedErrorBoundary';
import { FooterFallback } from '@components/RemoteMicroFrontends/fallbacks';
import { useAuthStoreContext } from '@context/authStore';
import { ErrorInfo, lazy, Suspense } from 'react';
import { Header } from './components';

const Footer = lazy(() => import('brightpathHeader/Footer'));

export const Layout = () => {
  const { isUpdatingUserPreferences } = useAuthStoreContext();

  return isUpdatingUserPreferences ? (
    <Loader />
  ) : (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Suspense fallback={null}>
        <FederatedErrorBoundary
          moduleName="brightpathFooter"
          fallback={<FooterFallback />}
          onError={(error: Error, errorInfo: ErrorInfo) => {
            console.error('Failed to load Footer:', error, errorInfo);
          }}
        >
          <Footer />
        </FederatedErrorBoundary>
      </Suspense>
    </>
  );
};
